/**
 * Las pantallas que entraron al shell nuevo POR EL DESKTOP —
 * ADR-2026-08-20-la-sidebar-vieja-la-elegia-el-grupo-de-rutas.
 *
 * Son las 13 rutas que hasta ahora vivían en el grupo de `DashboardLayout` y por eso
 * montaban el `<aside>` viejo también en desktop. Se mudaron al grupo del shell nuevo
 * para que la sidebar sea la misma en todos lados, pero NO nacieron para él: se
 * escribieron contra el panel de `.main-content` (ancho completo, alto definido, su
 * propio padding y sus propios tamaños de título).
 *
 * Esta lista es lo que las distingue de las secciones nativas del shell, y la leen dos
 * lugares por dos motivos distintos:
 *
 *  - `EstiloMinimal` la usa para hospedarlas en NEUTRO (sin la columna del 90% ni el
 *    reset de `.shell-seccion`) —
 *    ADR-2026-08-20-el-shell-hospeda-en-neutro-lo-que-no-nacio-para-la-columna.
 *  - `ShellMobile` la usa para dejarles la barra inferior VIEJA, que es la que tienen
 *    hoy. La mudanza es un arreglo de desktop; mobile no se toca.
 *
 * Prefijos, no rutas exactas: `/estudio-marketing` cubre sus ocho pantallas. Ojo con
 * `/subscription/success`, que va entero a propósito: `/subscription` (el catálogo de
 * planes) SÍ es nativa del shell desde ADR-2026-08-04-subscription-entra-al-shell-nuevo,
 * y un prefijo `/subscription` se la llevaría puesta.
 */
export const RUTAS_SHELL_LEGACY = [
  // Los tres modos con pantalla propia (`Modos.tsx` intercepta su path y navega acá).
  // Son los que enlaza "Todas las herramientas" de la sidebar nueva, o sea el camino
  // por el que se reportó el salto de chrome.
  '/shorts-studio',
  '/animar-imagen',
  '/carrusel',
  // La pantalla intermedia de los atajos —
  // ADR-2026-08-20-los-atajos-tienen-pantalla-propia-para-elegir-imagen. Está construida
  // con el mismo molde que los tres de arriba (`min-h-screen` + su propia columna
  // `max-w-content`), y en su paso 2 monta el visor del historial, que también trae lo
  // suyo. Con la columna del 90% del shell encima quedaría doblemente sangrada.
  '/atajo',
  // Pantalla dedicada del chat — la abre el botón de expandir de `PanelChatAtlas`.
  '/chat',
  // Estudio de marketing: el prefijo cubre mapa, plan, plan/:piezaId, insights,
  // estrategia, marca, datos y onboarding.
  '/estudio-marketing',
  // Post-checkout.
  '/subscription/success',
] as const;

/** `true` si `pathname` cae en una de las rutas mudadas (o en una hija suya). */
export function esRutaShellLegacy(pathname: string): boolean {
  return RUTAS_SHELL_LEGACY.some(
    (ruta) => pathname === ruta || pathname.startsWith(`${ruta}/`),
  );
}
